import React, { useId } from "react";

interface HoneypotFieldProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * A field no human can fill in, that a form-filling bot cannot resist.
 *
 * Positioned off screen rather than `display: none` or `hidden`, because the
 * better bots skip fields they can see are hidden. `tabIndex={-1}` keeps it out
 * of the keyboard order and `aria-hidden` keeps it away from screen readers, so
 * a real visitor can never reach it by accident.
 */
export default function HoneypotField({ value, onChange }: HoneypotFieldProps) {
  // The floater can be on screen at the same time as another form, so the id has
  // to be unique per instance. The `name` stays fixed - that is what the server reads.
  const fieldId = useId();

  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <label htmlFor={fieldId}>Company website (leave this field empty)</label>
      <input
        id={fieldId}
        name="company_url"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
      />
    </div>
  );
}
